import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { SimpleSignatureComponent } from "./components/simple-signature/simple-signature.component";
import { DebounceClickDirective } from "./directives/DebounceClickDirective";

@NgModule({
    imports: [
        CommonModule,
        IonicModule.forRoot(
            {}
        ),
    ],
    declarations: [
        DebounceClickDirective,
        SimpleSignatureComponent    
    ],
    exports:[
        DebounceClickDirective,
        SimpleSignatureComponent
    ],
    providers: [],
    entryComponents: [
        SimpleSignatureComponent    
     ]
})
export class AppCommonModule {
}